import {Tabs} from 'antd';
import {NewInvoice} from './NewInvoice';
import {ExistingInvoice} from './ExistingInvoice';
import {NewPurchaseOrder} from "./NewPurchaseOrder";
import {ExistingPurchaseOrder} from "./ExistingPurchaseOrder";
import {SalesHelp} from "./SalesHelp";
import {checkPerm} from "../../auth/sessionTools";
import {TaskTable} from "../tasks/TaskTable";

export const SalesTab = ({onApiFail, session, refresh, onRefresh, props}) => {
    const hasAllTasks = checkPerm(session, "allTask");

    const items = [
        {
            key: 'NewInvoice',
            label: 'New Invoice',
            children: <NewInvoice refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'ExistingInvoice',
            label: 'Existing Invoices',
            children: <ExistingInvoice refreshInvoice={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'NewPurchaseOrder',
            label: 'New Purchase Order',
            children: <NewPurchaseOrder onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'ExistingPurchaseOrder',
            label: 'Existing Purchase Order',
            children: <ExistingPurchaseOrder refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'Help',
            label: 'Help',
            children: <SalesHelp />
        }
    ]

    if (hasAllTasks) {
        items.push({
            key: 'DepartmentTasks',
            label: 'Sales Tasks',
            children: <TaskTable refresh={refresh} onApiFail={onApiFail} taskType={'department'} showVerified={false} department={`Sales`} />
        });
    }

    return <Tabs tabPosition={'left'} defaultActiveKey={'NewInvoice'} items={items} />
}